import React from 'react'
import utils from '../../utils'
import { Helmet } from 'react-helmet'
import ServiceStats from '../../components/services/ServiceStats'
import DashboardCategories from '../../components/services/DashboardCategories'
import DashboardServices from '../../components/services/DashboardServices'
import DashboardCounties from '../../components/services/DashboardCounties'

function ServiesAdminPage() {
    const url = window.location.href
    return (
        <div className='mb-16'>
            <Helmet>
                <title>Services Dashboard - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta
                    property="description"
                    content="" />
            </Helmet>
            <div className="container mx-auto space-y-6">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
                    <div>
                        <h1 className="text-3xl font-bold text-zinc-90 tracking-tight">Available Services</h1>
                        <p className="text-zinc-500 mt-1">Manage available counties, services and categories.</p>
                    </div>
                </div>
                <ServiceStats/>
                <DashboardCounties/>
                <DashboardCategories/>
                <DashboardServices/>
            </div>
        </div>
    )
}

export default ServiesAdminPage